import { FC, ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../common/routesUtils";
import { getCurrentUserData } from "../../state/auth";

interface Props {
	children?: ReactNode;
}

/**
 * Protected component checks if the user is authenticated.
 *
 * If the user is not authenticated (i.e., no JWT token can be found locally), it
 * will redirect the user to the "Sign in" section.
 *
 * This component should be used in conjuction with routes to protect unauthorized navigation.
 *
 * @param children the protected component
 * @returns        the protected component or will redirect user to "Sign In" app section
 */
const Protected: FC<Props> = ({ children }) => {
	const userData = getCurrentUserData();
	const navigateTo = useNavigate();

	useEffect(() => {
		if (!userData?.user || !userData.permissions || !userData.token) {
			navigateTo(AppRoutes.SignIn);
		}
	}, [navigateTo, userData]);

	return <>{children}</>;
};

export default Protected;
